// Per-service SVG illustrations (420×160 viewBox, white + cyan accent on dark).
// One bold focal concept each — order matches lib/data/services.ts.
const SERVICE_ILLUSTRATIONS = [
  /* 01 — Influencer Marketing: creator network hub */
  <svg
    key="01"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    {/* connectors */}
    <line x1="210" y1="80" x2="100" y2="44" stroke="white" strokeOpacity="0.22" strokeWidth="1.5" />
    <line x1="210" y1="80" x2="320" y2="44" stroke="white" strokeOpacity="0.22" strokeWidth="1.5" />
    <line
      x1="210"
      y1="80"
      x2="100"
      y2="116"
      stroke="white"
      strokeOpacity="0.22"
      strokeWidth="1.5"
    />
    <line
      x1="210"
      y1="80"
      x2="320"
      y2="116"
      stroke="white"
      strokeOpacity="0.22"
      strokeWidth="1.5"
    />
    {/* satellite — like */}
    <circle
      cx="100"
      cy="44"
      r="21"
      fill="#0c1730"
      stroke="white"
      strokeOpacity="0.38"
      strokeWidth="1.5"
    />
    <path
      d="M100 52C94 46 88 42 88 37C88 33.5 91 32 94 33.5C96 34.5 99 37 100 39C101 37 104 34.5 106 33.5C109 32 112 33.5 112 37C112 42 106 46 100 52Z"
      fill="#00b4d8"
      fillOpacity="0.8"
    />
    {/* satellite — play */}
    <circle
      cx="320"
      cy="44"
      r="21"
      fill="#0c1730"
      stroke="white"
      strokeOpacity="0.38"
      strokeWidth="1.5"
    />
    <path d="M315 37l12 7-12 7z" fill="white" fillOpacity="0.75" />
    {/* satellite — star */}
    <circle
      cx="100"
      cy="116"
      r="21"
      fill="#0c1730"
      stroke="white"
      strokeOpacity="0.38"
      strokeWidth="1.5"
    />
    <path
      d="M100 105L103 112L110 113L104 117L107 125L100 120L93 125L96 117L90 113L97 112Z"
      fill="white"
      fillOpacity="0.75"
    />
    {/* satellite — check */}
    <circle
      cx="320"
      cy="116"
      r="21"
      fill="#0c1730"
      stroke="white"
      strokeOpacity="0.38"
      strokeWidth="1.5"
    />
    <path
      d="M313 116l5 5 9-10"
      stroke="#00b4d8"
      strokeOpacity="0.9"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* center hub */}
    <circle
      cx="210"
      cy="80"
      r="34"
      fill="rgba(0,180,216,0.14)"
      stroke="#00b4d8"
      strokeOpacity="0.85"
      strokeWidth="2"
    />
    <circle
      cx="210"
      cy="70"
      r="9"
      stroke="white"
      strokeOpacity="0.92"
      strokeWidth="2.2"
      fill="none"
    />
    <path
      d="M192 98c0-10 8-16 18-16s18 6 18 16"
      stroke="white"
      strokeOpacity="0.92"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
  </svg>,

  /* 02 — Campaign Design: megaphone broadcasting signal */
  <svg
    key="02"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    {/* signal arcs */}
    <path
      d="M236 52c14 9 14 47 0 56"
      stroke="#00b4d8"
      strokeOpacity="0.75"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M266 38c24 14 24 70 0 84"
      stroke="#00b4d8"
      strokeOpacity="0.4"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M296 24c34 18 34 94 0 112"
      stroke="white"
      strokeOpacity="0.16"
      strokeWidth="1.8"
      strokeLinecap="round"
      fill="none"
    />
    {/* megaphone horn */}
    <path
      d="M104 66L104 94L142 94L210 122L210 38L142 66Z"
      fill="rgba(0,180,216,0.14)"
      stroke="white"
      strokeOpacity="0.88"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    {/* handle */}
    <rect
      x="110"
      y="94"
      width="26"
      height="30"
      rx="6"
      fill="#0c1730"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="2"
    />
    {/* endpoint dots */}
    <circle cx="248" cy="80" r="4" fill="#00b4d8" />
    <circle cx="280" cy="80" r="3.4" fill="#00b4d8" fillOpacity="0.6" />
    <circle cx="314" cy="80" r="2.8" fill="white" fillOpacity="0.3" />
  </svg>,

  /* 03 — Measurement & MMM: rising chart over bars */
  <svg
    key="03"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    {/* axes */}
    <line x1="74" y1="26" x2="74" y2="132" stroke="white" strokeOpacity="0.5" strokeWidth="2" />
    <line x1="74" y1="132" x2="350" y2="132" stroke="white" strokeOpacity="0.5" strokeWidth="2" />
    {/* bars */}
    <rect x="96" y="98" width="28" height="34" rx="3" fill="white" fillOpacity="0.14" />
    <rect x="144" y="80" width="28" height="52" rx="3" fill="white" fillOpacity="0.2" />
    <rect x="192" y="88" width="28" height="44" rx="3" fill="white" fillOpacity="0.14" />
    <rect
      x="240"
      y="62"
      width="28"
      height="70"
      rx="3"
      fill="rgba(0,180,216,0.22)"
      stroke="#00b4d8"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <rect x="288" y="46" width="28" height="86" rx="3" fill="white" fillOpacity="0.2" />
    {/* rising line */}
    <path
      d="M92 106L158 80L220 86L278 54L330 34"
      stroke="#00b4d8"
      strokeOpacity="0.92"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="158" cy="80" r="3.6" fill="#00b4d8" />
    <circle cx="278" cy="54" r="3.6" fill="#00b4d8" />
    <circle
      cx="330"
      cy="34"
      r="5.5"
      fill="#00b4d8"
      stroke="white"
      strokeOpacity="0.4"
      strokeWidth="1.6"
    />
  </svg>,

  /* 04 — Analysis & Compliance: verified document */
  <svg
    key="04"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    {/* document */}
    <rect
      x="138"
      y="22"
      width="142"
      height="116"
      rx="10"
      fill="rgba(255,255,255,0.04)"
      stroke="white"
      strokeOpacity="0.82"
      strokeWidth="2.4"
    />
    <rect x="158" y="40" width="72" height="8" rx="4" fill="white" fillOpacity="0.55" />
    <rect x="158" y="60" width="104" height="6" rx="3" fill="white" fillOpacity="0.2" />
    <rect x="158" y="74" width="104" height="6" rx="3" fill="white" fillOpacity="0.2" />
    <rect x="158" y="88" width="72" height="6" rx="3" fill="white" fillOpacity="0.2" />
    <rect x="158" y="106" width="104" height="6" rx="3" fill="white" fillOpacity="0.12" />
    <rect x="158" y="120" width="58" height="6" rx="3" fill="white" fillOpacity="0.12" />
    {/* verified seal */}
    <circle cx="284" cy="118" r="27" fill="#0b1629" />
    <circle
      cx="284"
      cy="118"
      r="23"
      fill="rgba(0,180,216,0.16)"
      stroke="#00b4d8"
      strokeOpacity="0.9"
      strokeWidth="2.4"
    />
    <path
      d="M273 118l8 8 14-16"
      stroke="#00b4d8"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>,

  /* 05 — Celebrity Ads: star under a spotlight */
  <svg
    key="05"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    <defs>
      <radialGradient id="svc05-spot" cx="50%" cy="0%" r="95%">
        <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
        <stop offset="100%" stopColor="rgba(255,255,255,0)" />
      </radialGradient>
    </defs>
    <path d="M210 12L294 142L126 142Z" fill="url(#svc05-spot)" />
    <line x1="210" y1="14" x2="126" y2="142" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />
    <line x1="210" y1="14" x2="294" y2="142" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />
    {/* lamp */}
    <circle
      cx="210"
      cy="14"
      r="9"
      fill="rgba(0,180,216,0.3)"
      stroke="#00b4d8"
      strokeOpacity="0.85"
      strokeWidth="2"
    />
    {/* stage */}
    <ellipse cx="210" cy="142" rx="80" ry="9" fill="white" fillOpacity="0.08" />
    <ellipse cx="210" cy="142" rx="46" ry="6" fill="rgba(0,180,216,0.14)" />
    {/* hero star */}
    <path
      d="M210 54L221 85L254 86L227 106L237 137L210 118L183 137L193 106L166 86L199 85Z"
      fill="rgba(0,180,216,0.2)"
      stroke="#00b4d8"
      strokeOpacity="0.9"
      strokeWidth="2.6"
      strokeLinejoin="round"
    />
    {/* flanking stars */}
    <path
      d="M96 58L98 65L106 65L100 69L102 76L96 72L90 76L92 69L86 65L94 65Z"
      fill="white"
      fillOpacity="0.32"
    />
    <path
      d="M324 58L326 65L334 65L328 69L330 76L324 72L318 76L320 69L314 65L322 65Z"
      fill="white"
      fillOpacity="0.32"
    />
  </svg>,

  /* 06 — Digital Billboard: screen with play + broadcast waves */
  <svg
    key="06"
    viewBox="0 0 420 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    <defs>
      <linearGradient id="svc06-scr" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="rgba(0,180,216,0.18)" />
        <stop offset="1" stopColor="rgba(3,53,183,0.1)" />
      </linearGradient>
    </defs>
    {/* screen frame */}
    <rect
      x="98"
      y="22"
      width="224"
      height="98"
      rx="12"
      fill="rgba(255,255,255,0.03)"
      stroke="white"
      strokeOpacity="0.82"
      strokeWidth="2.6"
    />
    <rect
      x="110"
      y="34"
      width="200"
      height="74"
      rx="6"
      fill="url(#svc06-scr)"
      stroke="rgba(0,180,216,0.25)"
      strokeWidth="1.2"
    />
    {/* play button */}
    <circle
      cx="210"
      cy="71"
      r="25"
      fill="rgba(0,180,216,0.18)"
      stroke="#00b4d8"
      strokeOpacity="0.88"
      strokeWidth="2.4"
    />
    <path d="M202 60L225 71L202 82Z" fill="white" fillOpacity="0.92" />
    {/* stand */}
    <line
      x1="210"
      y1="120"
      x2="210"
      y2="138"
      stroke="white"
      strokeOpacity="0.6"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    <rect x="172" y="138" width="76" height="8" rx="4" fill="white" fillOpacity="0.4" />
    {/* broadcast waves */}
    <path
      d="M330 42c9 6 9 28 0 36"
      stroke="#00b4d8"
      strokeOpacity="0.55"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M346 32c16 11 16 54 0 66"
      stroke="#00b4d8"
      strokeOpacity="0.26"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M90 42c-9 6-9 28 0 36"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
  </svg>,
]

export function ServiceIllustration({ idx }: { idx: number }) {
  return <div className="w-full flex-1 min-h-0 overflow-hidden">{SERVICE_ILLUSTRATIONS[idx]}</div>
}

export function NetworkBg() {
  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none select-none"
      viewBox="0 0 560 430"
      preserveAspectRatio="xMidYMid slice"
      fill="none"
      aria-hidden
    >
      <circle cx="542" cy="46" r="68" stroke="white" strokeOpacity="0.07" strokeWidth="1" />
      <circle cx="542" cy="46" r="138" stroke="white" strokeOpacity="0.05" strokeWidth="1" />
      <circle cx="542" cy="46" r="220" stroke="white" strokeOpacity="0.035" strokeWidth="1" />
      <circle cx="542" cy="46" r="316" stroke="white" strokeOpacity="0.02" strokeWidth="1" />
      <circle cx="542" cy="46" r="5" fill="white" fillOpacity="0.18" />
      <circle cx="542" cy="46" r="14" fill="white" fillOpacity="0.05" />
      <circle cx="374" cy="118" r="3.5" fill="white" fillOpacity="0.13" />
      <circle cx="446" cy="198" r="2.5" fill="white" fillOpacity="0.10" />
      <circle cx="276" cy="178" r="2" fill="white" fillOpacity="0.08" />
      <circle cx="484" cy="296" r="3" fill="white" fillOpacity="0.11" />
      <circle cx="318" cy="318" r="2" fill="white" fillOpacity="0.07" />
      <circle cx="196" cy="96" r="2" fill="white" fillOpacity="0.07" />
      <circle cx="146" cy="238" r="2" fill="white" fillOpacity="0.06" />
      <circle cx="514" cy="376" r="2" fill="white" fillOpacity="0.07" />
      <circle cx="356" cy="378" r="2.5" fill="white" fillOpacity="0.07" />
      <circle cx="96" cy="338" r="1.5" fill="white" fillOpacity="0.05" />
      <circle cx="228" cy="358" r="1.5" fill="white" fillOpacity="0.05" />
      <line
        x1="374"
        y1="118"
        x2="446"
        y2="198"
        stroke="white"
        strokeOpacity="0.07"
        strokeWidth="0.8"
      />
      <line
        x1="374"
        y1="118"
        x2="276"
        y2="178"
        stroke="white"
        strokeOpacity="0.06"
        strokeWidth="0.8"
      />
      <line
        x1="374"
        y1="118"
        x2="196"
        y2="96"
        stroke="white"
        strokeOpacity="0.05"
        strokeWidth="0.8"
      />
      <line
        x1="446"
        y1="198"
        x2="484"
        y2="296"
        stroke="white"
        strokeOpacity="0.07"
        strokeWidth="0.8"
      />
      <line
        x1="446"
        y1="198"
        x2="276"
        y2="178"
        stroke="white"
        strokeOpacity="0.05"
        strokeWidth="0.8"
      />
      <line
        x1="276"
        y1="178"
        x2="146"
        y2="238"
        stroke="white"
        strokeOpacity="0.05"
        strokeWidth="0.8"
      />
      <line
        x1="484"
        y1="296"
        x2="318"
        y2="318"
        stroke="white"
        strokeOpacity="0.06"
        strokeWidth="0.8"
      />
      <line
        x1="484"
        y1="296"
        x2="514"
        y2="376"
        stroke="white"
        strokeOpacity="0.05"
        strokeWidth="0.8"
      />
      <line
        x1="318"
        y1="318"
        x2="356"
        y2="378"
        stroke="white"
        strokeOpacity="0.05"
        strokeWidth="0.8"
      />
      <line
        x1="318"
        y1="318"
        x2="228"
        y2="358"
        stroke="white"
        strokeOpacity="0.04"
        strokeWidth="0.8"
      />
      <line
        x1="146"
        y1="238"
        x2="96"
        y2="338"
        stroke="white"
        strokeOpacity="0.04"
        strokeWidth="0.8"
      />
      <line
        x1="196"
        y1="96"
        x2="276"
        y2="178"
        stroke="white"
        strokeOpacity="0.04"
        strokeWidth="0.8"
      />
      <circle cx="458" cy="82" r="1" fill="white" fillOpacity="0.06" />
      <circle cx="492" cy="134" r="1" fill="white" fillOpacity="0.05" />
      <circle cx="418" cy="58" r="1" fill="white" fillOpacity="0.05" />
      <circle cx="344" cy="52" r="1" fill="white" fillOpacity="0.04" />
      <circle cx="244" cy="276" r="1" fill="white" fillOpacity="0.04" />
      <circle cx="176" cy="358" r="1" fill="white" fillOpacity="0.04" />
      <circle cx="420" cy="348" r="1" fill="white" fillOpacity="0.04" />
    </svg>
  )
}
